export default __webpack_public_path__ + "static/media/simple.f82884cc.jpg";